import PropTypes from "prop-types";
import { TextField, Box } from "@mui/material";

function DateField({ displayName, fieldRef, options }) {
  // console.log(options);
  return (
    <Box>
      <TextField
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="date"
        fullWidth
        variant="outlined"
        options={options}
        InputLabelProps={{
          sx: {
            whiteSpace: 'break-spaces',
          },
          shrink: true
        }}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
DateField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

DateField.defaultProps = {
  options: null,
};

export default DateField;
